<div class="nav-sidebar" [class.collapsed]="collapsed">
  <div class="nav-sidebar_mask"></div>
  <nav class="nav-sidebar_menu d-flex flex-column"
       [(siClickOutsideClose)]="collapsed"
       [siClickOutsideInactive]="clickOutsideInactive"
       siClickOutsideCloseButton="outsideCloseNavSidebar">
    <div *ngIf="items">
      <si-vertical-menu-ext [items]="items"
                            [hideSearch]="true"
                            styleClass="nav-menu"
      ></si-vertical-menu-ext>
    </div>
  </nav>
</div>

<ng-container *ngIf="showTour">
  <si-ngx-ui-tour [tourName]="ngxUiTourAppTours.MENU_TOUR"
                  (startedTour)="onStartTour()"
                  (endTourCompleted)="onFinishTour()"
                  (endTourUncompleted)="onFinishTour()"
  ></si-ngx-ui-tour>
</ng-container>
